import { OVsByFilters } from 'services/manage_ov/interface'
import { CustomBoolean } from 'constants/enums'

interface OrderProps {
  checked?: boolean
  CodigoCliente: string
  DataCriacaoPedido: string
  NomeCliente: string
  NumeroPedidoRascunho: string
  NumeroPedidoCliente: string | null
  QuantidadeTotalAtendida: number
  QuantidadeTotalNaoAtendida: number
  QuantidadeTotalSolicitada: number
  DescricaoStatusPedido: string
  TipoMaterial: CustomBoolean
  OrdensVendas: Ordemvenda[]
  QuantidadeSolicitadaConv: number
  QuantidadeTotalAtendidaConv: number
  QuantidadeTotalNaoAtendidaConv: number
  dt_ajst_pivo: string
  CodigoStatusPedido: number
  RowsCount: number
}

export interface DraftProps extends OVsByFilters, OrderProps {}

export const StatusOV = {
  '00- PENDENTE POR VENDEDOR': 'PENDENTE - 00',
  '05- PENDENTE POR INDISPONIBILIDADE': 'PENDENTE - 05',
  '08- PENDENTE N.D. VENDEDOR': 'PENDENTE - 08',
  '09- PENDENTE N.D. GRV': 'EM APROVAÇÃO - 09',
  '10- PENDENTE N.D. GNV': 'EM APROVAÇÃO - 10',
  '15- PENDENTE APROV.OV ESPECIAL': 'EM APROVAÇÃO - 15',
  '20- PENDENTE CRÉDITO/COBRANÇA-SAP': 'PENDENTE - 20',
  '21- PENDENTE ERRO DE CADASTRO-SAP': 'PENDENTE - 21',
  '22- PENDENTE ARQU.CUSTOMIZAÇÃO-SAP': 'PENDENTE - 22',
  '30- AGUARDANDO ENVIO PARA SAP': 'PROCESSANDO - 30',
  '40- TRANSMITIDO PARA O SAP': 'ENVIADO AO SAP - 40',
  '45- ESTOQUE INDISPONÍVEL(J0)-SAP': 'PROCESSANDO - 45',
  '50- AGUARDANDO RETORNO DO SAP': 'PROCESSANDO - 50',
  '60- EM PROCESSO DE RESERVA': 'EM RESERVA - 60',
  '65- REMESSA PARCIAL': 'EM REMESSA - 65',
  '70- EM PROCESSO DE REMESSA': 'EM REMESSA - 70',
  '75- FATURADO PARCIALMENTE': 'FATURAMENTO - 75',
  '80- FATURADO TOTALMENTE': 'FATURADO - 80',
  '90- CANCELADO TOTALMENTE': 'CANCELADO - 90'
} as const

export const statusOvKeys = Object.keys(StatusOV)
const validKeysToReturn = ['20', '21', '22', '40']
const validKeysToSend = ['00', '05', '08']
const validKeysToSalesArea = ['09', '10', '15']

export const statusToReturnToSalesArea = statusOvKeys.filter((statusKey) =>
  validKeysToSalesArea.includes(statusKey.split('-')[0])
) as StatusOVKeys[]

export const statusToReturnOvFromSap = statusOvKeys.filter((statusKey) =>
  validKeysToReturn.includes(statusKey.split('-')[0])
) as StatusOVKeys[]

export const statusToSendOvToSap = statusOvKeys.filter((statusKey) =>
  validKeysToSend.includes(statusKey.split('-')[0])
) as StatusOVKeys[]

export type StatusOVKeys = keyof typeof StatusOV
export type StatusOVValues = typeof StatusOV[StatusOVKeys]
export interface Ordemvenda {
  nr_orde_vend: string
  nr_doct_orde_vend?: string
  dt_dsjd_clie: string
  cd_stat_orde_vend: number
  ds_stat_orde_vend: StatusOVKeys
  dt_alte: string
  fl_negc_difd: CustomBoolean
  dt_just_negc_difd: string | null
}
